import useSWR from 'swr';
import type { Deal, DealSearchCondition, DealIndexVendor } from '~/models/Deal';
import { convertQueryStringUrl } from '~/utils/DealSearchConditionUtils';
import type { SwrReturnType } from '~/models/Api';

const paths = {
  index: '/vendors/deals',
  show: '/vendors/deals/:id'
};
type TIndex = (
  query: DealSearchCondition
) => SwrReturnType<Pageable<DealIndexVendor>>;
type TShow = (id: number | null) => SwrReturnType<Deal>;
type ReturnType = {
  index: TIndex;
  show: TShow;
};

export const useDeals = (): ReturnType => {
  const index: TIndex = (query: DealSearchCondition) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<Pageable<DealIndexVendor>>(
      convertQueryStringUrl(paths.index, query)
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  const show: TShow = (id: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<Deal>(
      id === null ? null : paths.show.replace(':id', String(id))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index, show };
};
